var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoterouterLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1650.000000pt",
    height: "1650.000000pt",
    viewBox: "0 0 1650.000000 1650.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1650.000000) scale(0.100000,-0.100000)",
    fill: "#007ade",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2180 13323 c-297 -31 -566 -193 -724 -435 -179 -276 -211 -597 -88 -903 29 -73 2 -30 842 -1323 426 -655 791 -1220 810 -1253 172 -303 536 -475 878 -415 384 67 665 364 712 753 19 158 -12 329 -86 473 -18 36 -226 362 -463 725 l-430 660 4616 3 c2539 1 4618 0 4620 -2 6 -6 -4611 -7095 -4618 -7090 -11 7 -1864 2857 -1862 2863 3 6 1967 1014 2773 1423 261 133 517 265 568 295 283 165 445 459 429 777 -7 137 -26 215 -83 333 -129 269 -386 452 -681 482 -209 22 -353 -20 -683 -198 -154 -84 -3261 -1676 -3685 -1889 -379 -190 -446 -236 -552 -376 -107 -143 -162 -296 -170 -477 -9 -187 32 -341 135 -506 146 -235 2974 -4570 3025 -4637 166 -221 355 -350 589 -402 117 -27 309 -22 431 10 195 50 386 171 508 321 92 112 6045 9263 6109 9390 89 177 121 346 100 526 -49 424 -342 754 -760 855 -72 18 -312 19 -6150 20 -3341 0 -6091 -1 -6110 -3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoterouterLogo);
export default __webpack_public_path__ + "static/media/noterouter-logo.2be715fbf4d800f67ecacdb5bc06c0b0.svg";
export { ForwardRef as ReactComponent };